export const getRequiredDepthForShutters = (
  bladeSize: string,
  fittingType: string,
) => {
  if (bladeSize === '' || fittingType === '') return [];

  const shutter76mmBlindDepths = [
    {
      fittingType: 'Reveal Fit',
      depth: '52mm',
    },
    {
      fittingType: 'Face Fit',
      depth: '15mm',
    },
  ];

  const shutter89mmBlindDepths = [
    {
      fittingType: 'Reveal Fit',
      depth: '60mm',
    },
    {
      fittingType: 'Face Fit',
      depth: '25mm',
    },
  ];

  if (bladeSize === '76mm') {
    return shutter76mmBlindDepths.filter(
      options => options.fittingType === fittingType,
    );
  } else {
    return shutter89mmBlindDepths.filter(
      options => options.fittingType === fittingType,
    );
  }
};
